import get from 'lodash/get';
import omit from 'lodash/omit';
import { Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { ApiError } from '../../../api';
import { ShowFieldErrors } from '../../../utils/forms';
import { FormFeedback } from '../FormFeedback';
import { FormFieldVisibility, FormLabel } from '../FormLabel';

interface FormCheckboxFieldProps {
  name: string;
  label: string;
  serverErrors?: ApiError;
  showServerFieldErrors?: ShowFieldErrors;
  setShowServerFieldErrors?: (showServerFieldErrors: ShowFieldErrors) => void;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  required?: boolean;
  srOnlyLabel?: boolean;
  visibility?: FormFieldVisibility;
  className?: string;
}

export const FormCheckboxField = ({
  name,
  label,
  serverErrors,
  showServerFieldErrors,
  setShowServerFieldErrors,
  errors,
  register,
  required = false,
  srOnlyLabel = false,
  className = 'mb-3',
  visibility,
  ...rest
}: FormCheckboxFieldProps & Parameters<typeof Form.Check>[0]) => (
  <Form.Group className={className} controlId={name}>
    <Form.Check
      label={
        <FormLabel required={required} visibility={visibility} srOnlyLabel={srOnlyLabel}>
          {label}
        </FormLabel>
      }
      {...register(name, {
        onChange: () =>
          setShowServerFieldErrors?.({
            ...omit(showServerFieldErrors, [name]),
          }),
      })}
      {...rest}
      isInvalid={!!errors[name] || !!get(showServerFieldErrors, name)}
    />
    <FormFeedback
      clientError={errors[name]}
      serverErrors={get(showServerFieldErrors, name) ? get(serverErrors?.body, name) : null}
    />
  </Form.Group>
);
